import { Injectable } from '@angular/core';

@Injectable()
export class Loader {
    private loader = 0;

    isLoading(): boolean {
        return this.loader > 0;
    }

    addLoader(): void {
        setTimeout(() => {
            this.loader++;
        });
    }

    removeLoader(): void {
        setTimeout(() => {
            if (this.loader > 0) {
                this.loader--;
            }
        }, 500);
    }
}
